let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kz4YQ")).then(() => parcelRequire('bQCtv'));